import { graphQLClient } from '@/contentful/contentful-config';
import { ISimoFromCms, IProduct } from '@/types/simo/products';
import {
  simoBasket,
  simoFrontPageQuery,
  simoSingleSubscriptionQuery,
  configurationOverviewPage,
  checkout
} from './queries';
type NominalSetState = React.Dispatch<React.SetStateAction<ISimoFromCms>>;

export const fetchSimoFromCms = async (setSimoItems: NominalSetState) => {
  try {
    const response = await graphQLClient.request(simoFrontPageQuery);

    const heroCms = response.hero.items[0].resourcesCollection.items;
    const faqCms = response.faq.items[0];
    const subscriptionCardCms = response.subscriptionCard.items[0].resourcesCollection.items;
    const campaignsCms = response.campaigns.items[0].productCodeCollection.items;
    const metaTagsCms = response.metaTags.items[0];
    const { componentsCollection, ...spotBoxSection } = response.spotBoxContainer.items[0];
    const spotBoxes = componentsCollection.items;
    setSimoItems({
      heroCms,
      faqCms,
      subscriptionCardCms,
      campaignsCms,
      spotBoxes,
      spotBoxSection,
      metaTagsCms
    });
  } catch (error) {
    console.log(error);
  }
};

export const fetchSingleSubscription = async (productCode: string) => {
  try {
    const response = await graphQLClient.request(simoSingleSubscriptionQuery);

    return response?.subscriptionCollection?.items.filter(
      (product: IProduct) => product.productCode === productCode
    );
  } catch (error) {
    console.log(error);
  }
};
type NominalState = React.Dispatch<React.SetStateAction<any>>;

export const fetchBasketFromCms = async (setBasketCms: NominalState) => {
  try {
    const response = await graphQLClient.request(simoBasket);
    const basket = response.basket.items[0];
    setBasketCms({ basket });
  } catch (error) {
    console.log(error);
  }
};

export const fetchConfigurationOverviewCms = async (setConfigurationCms: NominalState) => {
  try {
    const response = await graphQLClient.request(configurationOverviewPage);
    const configurationOverviewCms = response.simoConfigurationCollection.items[0];
    const faqs = { faqPortNumber: response.faqPortNumber, faqSaldoMax: response.faqSaldomax };
    setConfigurationCms({ ...configurationOverviewCms, faqs });
  } catch (error) {
    console.log(error);
  }
};

export const fetchCheckoutCms = async (setCheckoutCms: NominalState) => {
  try {
    const response = await graphQLClient.request(checkout);
    const checkoutCms = response.simoCheckoutCollection.items[0];
    setCheckoutCms({ checkoutCms });
  } catch (error) {
    console.log(error);
  }
};
